/* @flow */

import React, { Component } from 'react';
import { Modal, Button, Divider, Message } from 'semantic-ui-react';
import { ChromePicker } from 'react-color';

const DEFAULT_COLOR: string = '#FFFFFF';

type Props = {
  open: boolean,
  color?: string,
  onUpdate: (color: string) => void,
  onClose: () => void,
};

type State = {
  color: string,
};

const styles = {
  content: {
    margin: '0 auto',
    width: '35%',
  },
};

// TODO: display loader while loading image (see onImageLoaded props from ReactCrop)
class ImageExpand extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      color: props.color || DEFAULT_COLOR,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.color !== this.props.color) {
      this.setState({
        color: nextProps.color,
      });
    }
  }

  onColorChanged = value => this.setState({ color: value });

  onConfirm = () => this.props.onUpdate(this.state.color.hex);

  render() {
    const { open, onClose } = this.props;
    const { color } = this.state;

    return (
      <Modal closeIcon open={open} onClose={onClose} size="small">
        <Modal.Header>Elargissement de l'image</Modal.Header>
        <Modal.Content>
          <Message info>
            Choisissez une couleur de remplissage à utiliser lors de l'élargissement avec préservation du ratio
          </Message>
          <Divider hidden />
          <div style={styles.content}>
            <ChromePicker
              color={color}
              disableAlpha
              onChangeComplete={this.onColorChanged}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="button"
            onClick={this.onConfirm}
            positive
            icon="checkmark"
            labelPosition="right"
            content="Valider"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ImageExpand;



// WEBPACK FOOTER //
// ./src/shared/components/ImageExpand.js